import React from 'react';
import { Modal, Button, Header } from 'semantic-ui-react';

const KvkkModal = ({ open, onAccept, onReject }) => {
  return (
    <Modal
      open={open}
      size="fullscreen"
      dimmer="blurring"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Header icon="privacy" content="Kişisel Verilerin Korunması ve Aydınlatma Metni" />

      <Modal.Content
        scrolling
        style={{ flex: 1, overflowY: 'auto', paddingBottom: '2em' }}
      >
        <p><strong>Quders Q-Test Kapsamında KVKK ve GDPR Uyumlu Bilgilendirme</strong></p>
        <p>
          İşbu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") ve Avrupa Birliği
          Genel Veri Koruma Tüzüğü ("GDPR") kapsamında, kişisel verilerinizin işlenme koşulları hakkında
          sizleri bilgilendirmek amacıyla hazırlanmıştır.
        </p>

        <p><strong>1. Veri Sorumlusu</strong></p>
        <p>
          Bu hizmet, Quders markası altında Öykü Akyol Taşkol tarafından sunulmakta olup, veri sorumlusu sıfatını taşımaktadır.<br />
          <strong>İletişim:</strong> info@quders.com
        </p>

        <p><strong>2. İşlenen Kişisel Veriler</strong></p>
        <ul>
          <li>Kimlik Bilgileri: Ad, soyad</li>
          <li>İletişim Bilgileri: E-posta adresi, telefon numarası</li>
          <li>Kurumsal Bilgiler: Şirket adı, pozisyon</li>
          <li>Davranışsal Veriler: Test cevapları ve kişilik tipi sonucu</li>
          <li>Teknik Veriler: IP adresi ve oturum bilgileri gibi sınırlı teknik veriler</li>
        </ul>

        <p><strong>3. Kişisel Verilerin İşlenme Amaçları</strong></p>
        <ul>
          <li>Kişilik analizi sonuçlarının oluşturulması</li>
          <li>Size özel raporların hazırlanması ve e-posta ile iletilmesi</li>
          <li>Kurumsal analiz ve raporlama süreçleri</li>
          <li>Hizmet kalitesinin artırılması</li>
          <li>Talep ve şikayetlerin yönetimi</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi</li>
        </ul>

        <p><strong>4. Hukuki Dayanak</strong></p>
        <ul>
          <li>Açık rızanız (KVKK m.5/1, GDPR m.6/1-a)</li>
          <li>Sözleşmenin ifası için gerekli olması (KVKK m.5/2-c, GDPR m.6/1-b)</li>
          <li>Quders’in meşru menfaati (KVKK m.5/2-f, GDPR m.6/1-f)</li>
        </ul>

        <p><strong>5. Saklama Süresi</strong></p>
        <p>
          Verileriniz yalnızca yukarıdaki amaçlarla ve yasal süre boyunca saklanır. Süre sonunda silinir,
          yok edilir veya anonimleştirilir.
        </p>

        <p><strong>6. Verilerin Aktarımı</strong></p>
        <p>
          Kişisel verileriniz yalnızca teknik altyapı ve yazılım sağlayıcılarla gizlilik taahhüdü altında
          paylaşılır. Reklam veya ticari amaçlarla asla paylaşılmaz.
        </p>

        <p><strong>7. Haklarınız</strong></p>
        <ul>
          <li>Verilerin işlenip işlenmediğini öğrenme</li>
          <li>Erişim ve düzeltme talep etme</li>
          <li>Silinmesini veya yok edilmesini talep etme</li>
          <li>İşleme itiraz veya kısıtlama talebi</li>
          <li>Verilerin başka sisteme taşınmasını isteme (GDPR)</li>
        </ul>

        <p>
          Bu haklarınızı kullanmak için <strong>info@quders.com</strong> adresi üzerinden bizimle
          iletişime geçebilirsiniz.
        </p>

        <p><strong>8. Güvenlik</strong></p>
        <p>
          Quders, verilerinizi korumak için tüm teknik ve idari önlemleri alır. Sunucular şifrelenmiş,
          erişim güvenliği sağlanmıştır.
        </p>

        <p style={{ marginTop: '1.5em' }}>
          <strong>Açık Rıza Beyanı:</strong><br />
          Aydınlatma metnini okudum ve Quders Q-Test platformunun yukarıda belirtilen amaçlar doğrultusunda
          kişisel verilerimi işlemesine açık rıza gösteriyorum.
        </p>
      </Modal.Content>

      <Modal.Actions style={{ flexShrink: 0, display: 'flex', justifyContent: 'center', gap: '1em' }}>
  <Button onClick={onReject} color="red">
    Reddet ve Çık
  </Button>
  <Button onClick={onAccept} color="green">
    Kabul Et ve Devam Et
  </Button>
</Modal.Actions>

    </Modal>
  );
};

export default KvkkModal;
